import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import { isMainPhotosAlbum, isSpecialtyAlbum } from '../../../../../util/album';
import AlbumUploadButton from './components/AlbumUploadButton';
import Button from '../../../../../components/global/Button';
import Angle from '../../../../../components/global/Angle';
import { canUploadToSpecialtyEventAlbums } from '../../helpers';

const propTypes = {
  albumFolder: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
  }).isRequired,
  waldofiedAlbum: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
  }).isRequired,
  onUpload: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
};

const AlbumSelectStep = ({ albumFolder, waldofiedAlbum, onUpload, onBack }) => {
  const albums = [
    waldofiedAlbum,
    ...albumFolder?.children?.albums?.records?.filter(
      album =>
        !isMainPhotosAlbum(album, !!waldofiedAlbum) &&
        !isSpecialtyAlbum(album) &&
        // confirms permission:
        canUploadToSpecialtyEventAlbums([album]),
    ),
  ];

  return (
    <Fragment>
      <Button
        btnStyle="link"
        className="specialty-event-upload-btn-dismiss"
        onClick={onBack}
      >
        <Angle direction="left" />
      </Button>
      <h2 className="text-center">Select an album to upload to:</h2>
      {}
      <div className="specialty-event-upload-album-select">
        {albums.map(album => (
          <AlbumUploadButton key={album.id} album={album} onUpload={onUpload} />
        ))}
      </div>
    </Fragment>
  );
};

AlbumSelectStep.propTypes = propTypes;

export default AlbumSelectStep;
